import { css } from '@emotion/react';
import { breakpoints, useNavSize } from '@frontend/responsiveness';
import { SideNav } from '../side-nav/side-nav';
import { TopNav } from '../top-nav/top-nav';

type Props = {
  children: React.ReactNode;
};

const styles = {
  content: (isMobile: boolean) =>
    css([
      {
        overflowY: 'auto',
        maxHeight: '100%',
        position: 'relative',

        '.wv-tray': {
          position: 'fixed',
          height: 'calc(100vh - 64px)',
          width: '100%',
          top: '64px',
          left: 0,

          '&:focus-visible': {
            outline: 0,
          },

          [`@media(min-width:  ${breakpoints.large.min}px)`]: {
            left: '248px',
            width: 'calc(100% - 248px)',
          },
        },
      },
      isMobile
        ? { width: '100%' }
        : {
            width: 'calc(100% - 248px)',
          },
    ]),
};

export const AuthRoute = (props: Props) => {
  const navSize = useNavSize();

  const isSmallerThanDesktop = navSize.isLt('large');

  return (
    <main>
      <TopNav />
      <div css={{ display: 'flex', height: 'calc(100vh - 64px)' }}>
        <SideNav />
        <section id='tray-target' css={styles.content(isSmallerThanDesktop)}>
          {props.children}
        </section>
      </div>
    </main>
  );
};
